import { resolveUrl } from '@wix/sdk-runtime/rest-modules';
import { ResolveUrlOpts } from '@wix/sdk-runtime/rest-modules';
import { RequestOptionsFactory } from '@wix/sdk-types';

function resolveComWixpressViCaptcharatorCaptchaServiceUrl(
  opts: Omit<ResolveUrlOpts, 'domainToMappings'>
) {
  const domainToMappings = {
    'api._api_base_domain_': [
      {
        srcPath: '/captcharator-web',
        destPath: '',
      },
    ],
    'api._base_domain_': [
      {
        srcPath: '/_api/captcharator',
        destPath: '',
      },
    ],
    'www._base_domain_': [
      {
        srcPath: '/_api/captcharator',
        destPath: '',
      },
      {
        srcPath: '/_api/captcharator-web',
        destPath: '/api',
      },
      {
        srcPath: '/_api/captcha',
        destPath: '/api',
      },
    ],
    'manage._base_domain_': [
      {
        srcPath: '/_api/captcha',
        destPath: '/api',
      },
      {
        srcPath: '/_api/captcharator',
        destPath: '',
      },
      {
        srcPath: '/_api/captcharator-web',
        destPath: '/api',
      },
    ],
    'www.wixapis.com': [
      {
        srcPath: '/captcharator/api/v1/authorize',
        destPath: '/api/v1/authorize',
      },
    ],
    _: [
      {
        srcPath: '/captcharator/api/v1/authorize',
        destPath: '/api/v1/authorize',
      },
    ],
    '*.dev.wix-code.com': [
      {
        srcPath: '/captcharator/api/v1/authorize',
        destPath: '/api/v1/authorize',
      },
    ],
  };

  return resolveUrl(Object.assign(opts, { domainToMappings }));
}

const PACKAGE_NAME = '@wix/auto_sdk_captcha_captcha';

/**
 * Authorizes a CAPTCHA token.
 *
 * Following CAPTCHA verification on the client side, you must authorize the generated CAPTCHA
 * token in the backend.
 *
 * `Authorize` checks if the token is valid, making sure it was not tampered with or timed out.
 *
 * If you're developing a Wix site or Blocks app, call this method when working with the
 * [Wix reCAPTCHA](https://dev.wix.com/docs/velo/api-reference/$w/captcha/introduction) element.
 *
 * If CAPTCHA token authorization fails, the method returns an error message containing a status code.
 * The following table lists the possible HTTP error status codes, based on
 * [RFC 2616](https://datatracker.ietf.org/doc/html/rfc2616#section-10):
 *
 *
 * | Status Code | Name | Description |
 * |---|---|---|
 * | 400 | Bad Request | The request could not be understood by the server. This could occur for a number of reasons, such as: <ul> <li>The request was sent without a token.</li> <li>The token is invalid.</li> <li>The token has timed out.</li> </ul> |
 * | 401 | Unauthenticated | No user identity found in passed request. |
 * | 500 | Internal Server Error | The server encountered an unexpected condition, such as a missing or invalid private CAPTCHA key. |
 * | 503 | Unavailable | The service is unavailable due to one of the following: <ul> <li>Throttled error: Server overload due to more than the allowed requests in a given time frame.</li> <li>Request failed: No response following 10 retries with a 1-second interval.</li> </ul> |
 */
export function authorize(payload: object): RequestOptionsFactory<any> {
  function __authorize({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.captcharator.v1.captcha_entity',
      method: 'POST' as any,
      methodFqn: 'com.wixpress.vi.captcharator.CaptchaService.authorize',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressViCaptcharatorCaptchaServiceUrl({
        protoPath: '/api/v1/authorize',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __authorize;
}
